import { Component, OnInit, ViewEncapsulation, AfterViewInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { MatTableDataSource } from '@angular/material';
import { ClaimLevel, EmployeeSearchResult } from '@akiba/models_bimbo';
import { AuthenticationService } from '../../../services/authentication.service';
import { DataSourceService } from '../../../services/data-source.service';
import { LogicService } from '../../../services/logic.service';

@Component({
  selector: 'app-pending-list',
  templateUrl: './pending-list.component.html',
  styleUrls: ['./pending-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PendingListComponent implements OnInit, OnDestroy {

  listener: Subscription;
  displayedColumns: string[] = ['employeeNumber', 'username', 'email', 'company', 'details'];
  dataSource: MatTableDataSource<any>;

  statePagination: { currentRefinement: number, nbPages: number, refine: Function } = {
    currentRefinement: 0,
    nbPages: 0,
    refine() { }
  };

  statePaginationRefine(page: number) {
    this.statePagination.refine(page);
  }

  get pages(): number[] {
    return Array.apply(null, { length: this.statePagination.nbPages }).map(Number.call, Number);
  }

  constructor(private ds: DataSourceService, private authService: AuthenticationService, public logicService: LogicService) {

    this.listener = this.authService.authUserSubject.subscribe((result) => {

      if (result) {
        this.logicService.dataManager.proxyDataLoader.employee = null;
        this.logicService.dataManager.generalDataLoader.load();
        this.logicService.dataManager.parameterDataLoader.load();
      }

    });

  }

  ngOnInit() {
    this.handleChange();

  }


  paginationState = (state, isFirstRendering) => {

    if (isFirstRendering) {
      return Promise.resolve(null).then(() => {
        this.statePagination = state;
      });
    }

    this.statePagination = state;

  }

  handleChange() {

    this.ds.logs('logAvailableMoney', 1, 20 ).then(result => {
      console.log ('result', result);
      //this.stateHits = result.hits;
      //this.dataSource = new MatTableDataSource(this.stateHits.hits.map((hit: any) => new EmployeeSearchResult(hit._source)));
    }).catch(error => console.log(error));

  }

  ngOnDestroy(): void {
    this.logicService.dataManager.proxyDataLoader.employee = null;
    if (this.listener && !this.listener.closed) {
      this.listener.unsubscribe();
      this.listener = null;
    }
  }

}
